import { useEffect, useState } from 'react';

import { useQuery } from '@tanstack/react-query';

import { getBankDataFreshness } from './display';
import type { BankDataFreshness } from './display';
import { accountBalanceQueries } from './queries';

// Staleness is a function of the clock, not just the data -- a tab left
// open must still flip to "stale" once the threshold passes even if no
// new balance rows arrive (which is exactly the broken-connection case).
const RECHECK_INTERVAL_MS = 5 * 60 * 1000;

function useNow(intervalMs: number): number {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), intervalMs);
    return () => clearInterval(id);
  }, [intervalMs]);
  return now;
}

export function useBankDataFreshness(
  accountId: string | undefined,
): BankDataFreshness | null {
  const { data: balances = [] } = useQuery(accountBalanceQueries.list());
  const now = useNow(RECHECK_INTERVAL_MS);
  return accountId ? getBankDataFreshness(balances, accountId, now) : null;
}
